import { defineComponent as _defineComponent } from 'vue'
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import BasicButton from '@/ui-components/BasicButton.vue';
import { formattedReleaseDate as formatReleaseDate } from '@/helpers/date-helper';
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { useConstantStore, useLanguageStore } from '@/helpers/composables/useStores';
import { computed } from 'vue';
import { UpcomingRelease } from '@/@types/graphql-types';
import { faBell, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { jwCheckIcon } from '@/plugins/global-fontawesome';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpcomingBox',
  props: {
    release: null,
    isInWatchlist: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { release: UpcomingRelease, isInWatchlist: boolean };

const CountrySwitcherModal = () => import('@/features/buybox/components/CountrySwitcherModal.vue');



const upcomingProviderIcon = computed(() => {
	if (!props.release.package || ['imd', 'tmd'].includes(props.release.package.shortName)) {
		const icon = props.release.releaseType === 'THEATRICAL' ? 'JW_cinema_icon' : 'JW_streaming_icon';
		return `https://www.justwatch.com/${ASSETS_DIR}/img/icons/${icon}.{format}`;
	}
	return props.release.package?.icon;
});

const { allProvidersById } = useConstantStore();
const { countryEmoji, language, country } = useLanguageStore();

const formattedReleaseDate = computed(() =>
	formatReleaseDate(props.release.releaseDate, props.release.label, language.value, 'long', country.value, true)
);

const releaseCounterClass = computed(() =>
	formattedReleaseDate.value ? 'upcoming-box__title-info--countdown' : 'upcoming-box__title-info--no-date'
);

const showProviderIcon = computed(() => {
	const id = props.release.package?.packageId;
	return !!id && id !== 0 && id in allProvidersById.value;
});

function openCountrySwitcherModal() {
	ModalHelper.openModal(CountrySwitcherModal, { closable: true });
	TrackingHelper.trackEvent('userinteraction', {
		action: 'country_selector_clicked',
	});
}

return { __sfc: true,CountrySwitcherModal, props, upcomingProviderIcon, allProvidersById, countryEmoji, language, country, formattedReleaseDate, releaseCounterClass, showProviderIcon, openCountrySwitcherModal, ProviderIcon, BasicButton, faBell, faAngleDown, jwCheckIcon }
}

})